import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import callApi from "services/api";
import { setAlertMessage } from "state/slices/alertSlice";
import { setLoading } from "state/slices/loaderSlice";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";
const AddUpdateUser = () => {
  const initialState = {
    id: "",
    name: "",
    mobileNumber: "",
    gender: "",
    email: "",
    stateId: "",
    districtId: "",
    role: "",
    designationId: "",
    policeStateId: "",
    policeDistrictId: "",
    policeStationId: "",
    policePostId: "",
    beltNo: "",
    houseNo: "",
    city: "",
    village: "",
    pincode: "",
    barCouncilName: "",
    provisionalNo: "",
    employeeCode: "",
    editingAllowed: true,
  };
  const location = useLocation();
  const { userToUpdate } = location?.state || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [policeStates, setPoliceStates] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [policeDistricts, setPoliceDistricts] = useState([]);
  const [policeStation, setPoliceStation] = useState([]);
  const [policePost, setPolicePost] = useState([]);
  const [userForm, setUserForm] = useState(initialState);
  const [userValidationErrors, setuserValidationErrors] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    masterData();
  }, []);

  Confirm.init({
    width: "500px",
    fontSize: "16px",
    messageMaxLength: 1000,
    cssAnimationStyle: "zoom",
  });

  const masterData = async () => {
    dispatch(setLoading(true));

    let stateResponse = await callApi(
      "/v1/api/states",
      "GET",
      null,
      false,
      true,
      dispatch,
      navigate
    );

    if (stateResponse?.success) {
      const statesList = stateResponse?.body?.body || [];
      setStates(statesList);
      const haryanaState = statesList.find(
        (state) => state.stateName?.toUpperCase() === "HARYANA"
      );

      if (haryanaState) {
        setUserForm((prev) => ({
          ...prev,
          stateId: haryanaState.id,
        }));
        fetchDistrictsByState(haryanaState.id);
      }
    }

    let policeStateResponse = await callApi(
      "/v1/api/states?police=true",
      "GET",
      null,
      false,
      true,
      dispatch,
      navigate
    );

    if (policeStateResponse?.success) {
      const policeStatesList = policeStateResponse?.body?.body || [];
      setPoliceStates(policeStatesList);
      const haryanaPoliceState = policeStatesList.find(
        (state) => state.stateName?.toUpperCase() === "HARYANA"
      );

      if (haryanaPoliceState) {
        setUserForm((prev) => ({
          ...prev,
          policeStateId: haryanaPoliceState.id,
        }));
        fetchPoliceDistrictsByState(haryanaPoliceState.id);
      }
    }

    setIsDataLoaded(true);
    dispatch(setLoading(false));
  };

  useEffect(() => {
    if (userToUpdate && isDataLoaded) {

      const loadEditData = async () => {

        setUserForm({
          id: userToUpdate?.id || "",
          name: userToUpdate?.name || "",
          mobileNumber: userToUpdate?.mobileNumber || "",
          gender: userToUpdate?.gender || "",
          email: userToUpdate?.email || "",
          stateId: userToUpdate?.stateId || "",
          districtId: userToUpdate?.districtId || "",
          role: userToUpdate?.role || "",
          designationId: userToUpdate?.designationId || "",

          policeStateId: userToUpdate?.policeStateId || "",
          policeDistrictId: userToUpdate?.policeDistrictId || "",
          policeStationId: userToUpdate?.policeStationId || "",
          policePostId: userToUpdate?.policePostId || "",

          beltNo: userToUpdate?.beltNo || "",
          houseNo: userToUpdate?.houseNo || "",
          city: userToUpdate?.city || "",
          village: userToUpdate?.village || "",
          pincode: userToUpdate?.pincode || "",

          barCouncilName: userToUpdate?.barCouncilName || "",
          provisionalNo: userToUpdate?.provisionalNo || userToUpdate?.provisionalNo || "",
          employeeCode: userToUpdate?.employeeCode || "",
          editingAllowed: userToUpdate?.editingAllowed || false,
        });


        if (userToUpdate?.stateId) {
          await fetchDistrictsByState(userToUpdate.stateId);
        }

        if (userToUpdate?.policeStateId) {
          await fetchPoliceDistrictsByState(userToUpdate.policeStateId);
        }

        if (userToUpdate?.policeDistrictId) {
          await PoliceStationList(userToUpdate.policeDistrictId);
        }

        if (userToUpdate?.policeStationId) {
          await PolicePostList(userToUpdate.policeStationId);
        }

        if (userToUpdate?.role) {
          await fetchDesignationsByRole(userToUpdate.role);
        }
      };

      loadEditData();
    }
  }, [userToUpdate, isDataLoaded]);

  const userTypes = [
    { value: "Police", label: "Police" },
    { value: "StationHead", label: "SHO" },
    { value: "DistrictHead", label: "CP/SP" },
    { value: "Advocate", label: "Advocate" },
    { value: "Admin", label: "Admin" },
  ];

  const userInputHandler = async (e) => {
    const { name, value } = e.target;

    setUserForm((prev) => {
      let updatedForm = { ...prev, [name]: value };

      if (name === "role") {
        updatedForm.designationId = "";
        updatedForm.policeDistrictId = "";
        updatedForm.policeStationId = "";
        updatedForm.policePostId = "";
        updatedForm.beltNo = "";
        updatedForm.barCouncilName = "";
        updatedForm.provisionalNo = "";
        updatedForm.employeeCode = "";

        fetchDesignationsByRole(value);
      }

      if (name === "stateId") {
        updatedForm.districtId = "";
        fetchDistrictsByState(value);
      }

      if (name === "policeDistrictId") {
        updatedForm.policeStationId = "";
        updatedForm.policePostId = "";
        setPolicePost([]);
        PoliceStationList(value);
      }

      if (name === "policeStationId") {
        updatedForm.policePostId = "";
        PolicePostList(value);
      }

      return updatedForm;
    });

    if (userValidationErrors[name]) {
      setuserValidationErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateUserForm = () => {
    const errors = {};
    const {
      role,
      policeStateId,
      policeDistrictId,
      policeStationId,
      policePostId,
      name,
      beltNo,
      mobileNumber,
      gender,
      email,
      districtId,
    } = userForm;

    if (!name) {
      errors.name = "Name is required";
    } else if (name.length < 2 || name.length > 100) {
      errors.name = "Name must be between 2 and 100 characters";
    }
    if (!mobileNumber) {
      errors.mobileNumber = "Mobile Number is required";
    } else if (mobileNumber.length !== 10 || !/^\d{10}$/.test(mobileNumber)) {
      errors.mobileNumber = "Mobile Number must be exactly 10 digits";
    }

    if (!gender) {
      errors.gender = "Gender is required";
    }

    if (!email) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      errors.email = "Email is invalid";
    }

    if (
      role === "Police" ||
      role === "StationHead" ||
      role === "DistrictHead"
    ) {
      if (!policeStateId) {
        errors.policeStateId = "State is required";
      }
      if (!policeDistrictId)
        errors.policeDistrictId = "District is required";

      if (!beltNo)
        errors.beltNo = "Belt No is required";
    }

    if (role === "StationHead" || role === "Police") {
      if (!policeStationId)
        errors.policeStationId = "Police Station is required";
    }

    if (role === "Police") {
      if (!policePostId)
        errors.policePostId = "Police Post is required";
    }

    if (!districtId) {
      errors.districtId = "District is required";
    }

    if (role && role !== "Advocate" && !userForm.designationId)
      errors.designationId = "Designation is required";

    if (!role)
      errors.role = "User Type is required";
    if (!userForm.houseNo) errors.houseNo = "House No is required";
    if (!userForm.city) errors.city = "City is required";
    if (!userForm.stateId) errors.stateId = "State is required";
    if (!userForm.pincode) {
      errors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(userForm.pincode)) {
      errors.pincode = "Pincode must be 6 digits";
    }

    if (role === "Advocate") {
      if (!userForm.barCouncilName)
        errors.barCouncilName = "Bar Council Name is required";

      if (!userForm.provisionalNo)
        errors.provisionalNo = "Enrollment / Registration Number / P No is required";

      // if (!userForm.employeeCode)
      //   errors.employeeCode = "Employee Code is required";
    }

    setuserValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handelUserSubmit = async (e) => {
    e.preventDefault();
    if (!validateUserForm()) return;
    if (userToUpdate) {
      await submitUser();
      return;
    }

    Confirm.show(
      "Confirm User Creation",
      `Please ensure the email and phone number are correct.\n\nLogin credentials will be sent to: \n\n Email: ${userForm.email}\nMobile: ${userForm.mobileNumber}`,
      "Yes, Create User",
      "Cancel",
      async () => {
        await submitUser();
      },
      () => { },
      {
        okButtonBackground: "#32c682",
        cancelButtonBackground: "#d33",
        okButtonColor: "#fff",
        cancelButtonColor: "#fff",
        borderRadius: "10px",
        fontFamily: "inherit",
        width: "400px",
      }
    );
  };


  const submitUser = async () => {
    try {
      dispatch(setLoading(true));

      const response = await callApi(
        "/v1/api/user",
        "POST",
        userForm,
        true,
        true,
        dispatch,
        navigate
      );

      if (response?.success) {
        dispatch(
          setAlertMessage(
            `User ${userToUpdate ? "updated" : "created"} successfully|true`
          )
        );
        navigate(-1);
      }
    } catch (err) {
      dispatch(
        setAlertMessage(
          "Something went wrong. Please contact administrative team.|false"
        )
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

  const PoliceStationList = async (districtId) => {
    let policeResponse = await callApi(
      `/v1/api/police-stations/${districtId}`,
      "GET",
      null,
      false,
      true,
      dispatch,
      navigate
    );
    if (policeResponse?.success) {
      setPoliceStation(policeResponse?.body?.body || []);
    } else {
      setPoliceStation([]);
    }
  };

  const PolicePostList = async (policestationId) => {
    let policeResponse = await callApi(
      `/v1/api/police-posts/${policestationId}`,
      "GET",
      null,
      false,
      true,
      dispatch,
      navigate
    );

    if (policeResponse?.success) {
      setPolicePost(policeResponse?.body?.body || []);
    } else {
      setPolicePost([]);
    }
  };

  const fetchDesignationsByRole = async (role) => {
    let response = await callApi(
      `/v1/api/designations/${role}`,
      "GET",
      null,
      false,
      true,
      dispatch,
      navigate
    );
    if (response?.success) {
      setDesignations(response?.body?.body || []);
    } else {
      setDesignations([]);
    }
  };

  const fetchDistrictsByState = async (stateId) => {
    let response = await callApi(
      `/v1/api/districts/${stateId}`,
      "GET",
      null,
      false,
      true,
      dispatch,
      navigate
    );
    if (response?.success) {
      setDistricts(response?.body?.body || []);
    } else {
      setDistricts([]);
    }
  };

  const fetchPoliceDistrictsByState = async (stateId) => {
    let response = await callApi(
      `/v1/api/districts/${stateId}`,
      "GET",
      null,
      false,
      true,
      dispatch,
      navigate
    );
    if (response?.success) {
      setPoliceDistricts(response?.body?.body || []);
    } else {
      setPoliceDistricts([]);
    }
  };

  const disableBottomFields = Boolean(!userForm.editingAllowed);

  return (
    <>
      <div className="container mb-3">
        <div className="card">
          <div
            className="ms-3 me-3 mt-3 p-2 d-flex justify-content-between"
            style={{ backgroundColor: "#262E3D", borderRadius: "8px" }}
          >
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-sm btn-secondary me-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <span className="card-title text-white m-0">
                {userToUpdate ? "Update" : "New"} User Registration Form
              </span>
            </div>
          </div>
          <div className="card-body">
            <form onSubmit={handelUserSubmit}>
              {/* Name */}
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label">
                  Name
                  <span className="ms-1" style={{ color: "red" }}>
                    *
                  </span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className={`form-control ${userValidationErrors.name ? "is-invalid" : ""
                      }`}
                    placeholder="Enter Name"
                    name="name"
                    onChange={userInputHandler}
                    value={userForm.name}
                    maxLength={100}
                  />
                  {userValidationErrors.name && (
                    <div className="invalid-feedback">
                      {userValidationErrors.name}
                    </div>
                  )}
                </div>
              </div>
              {/* Gender */}
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label">
                  Gender
                  <span className="ms-1" style={{ color: "red" }}>
                    *
                  </span>
                </label>
                <div className="col-sm-9">
                  <select
                    className={`form-control ${userValidationErrors.gender ? "is-invalid" : ""
                      }`}
                    name="gender"
                    onChange={userInputHandler}
                    value={userForm.gender}
                  >
                    <option value="">Select Gender</option>
                    <option value="MALE">Male</option>
                    <option value="FEMALE">Female</option>
                  </select>
                  {userValidationErrors.gender && (
                    <div className="invalid-feedback">
                      {userValidationErrors.gender}
                    </div>
                  )}
                </div>
              </div>
              {/* Mobile Number */}
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label">
                  Mobile Number
                  <span className="ms-1" style={{ color: "red" }}>
                    *
                  </span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className={`form-control ${userValidationErrors.mobileNumber ? "is-invalid" : ""
                      }`}
                    placeholder="Enter 10 digit Mobile Number"
                    name="mobileNumber"
                    onChange={userInputHandler}
                    value={userForm.mobileNumber}
                    maxLength={10}
                  />
                  {userValidationErrors.mobileNumber && (
                    <div className="invalid-feedback">
                      {userValidationErrors.mobileNumber}
                    </div>
                  )}
                </div>
              </div>

              {/* Email */}
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label">
                  Email
                  <span className="ms-1" style={{ color: "red" }}>
                    *
                  </span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="email"
                    className={`form-control ${userValidationErrors.email ? "is-invalid" : ""
                      }`}
                    placeholder="Enter Email"
                    name="email"
                    onChange={userInputHandler}
                    value={userForm.email}
                  />
                  {userValidationErrors.email && (
                    <div className="invalid-feedback">
                      {userValidationErrors.email}
                    </div>
                  )}
                </div>
              </div>
              <div className="card mb-3">
                <div className="card-header bg-light fw-bold">
                  Address Details
                </div>
                <div className="card-body">

                  <div className="row">
                    {/* House No */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label">
                        House No <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${userValidationErrors.houseNo ? "is-invalid" : ""}`}
                        name="houseNo"
                        value={userForm.houseNo}
                        onChange={userInputHandler}
                      />
                      {userValidationErrors.houseNo && (
                        <div className="invalid-feedback">
                          {userValidationErrors.houseNo}
                        </div>
                      )}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">
                        City <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${userValidationErrors.city ? "is-invalid" : ""}`}
                        name="city"
                        value={userForm.city}
                        onChange={userInputHandler}
                      />
                      {userValidationErrors.city && (
                        <div className="invalid-feedback">
                          {userValidationErrors.city}
                        </div>
                      )}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">
                        Village
                      </label>
                      <input
                        type="text"
                        className={`form-control ${userValidationErrors.village ? "is-invalid" : ""}`}
                        name="village"
                        value={userForm.village}
                        onChange={userInputHandler}
                      />
                      {userValidationErrors.village && (
                        <div className="invalid-feedback">
                          {userValidationErrors.village}
                        </div>
                      )}
                    </div>


                  </div>

                  <div className="row">
                    {/* State */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label">
                        State <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className={`form-control ${userValidationErrors.stateId ? "is-invalid" : ""}`}
                        name="stateId"
                        onChange={userInputHandler}
                        value={userForm.stateId}
                      >
                        <option value="">--Select State--</option>
                        {states?.map((state) => (
                          <option key={state?.id} value={state?.id}>
                            {state?.stateName}
                          </option>
                        ))}
                      </select>
                      {userValidationErrors.stateId && (
                        <div className="invalid-feedback">
                          {userValidationErrors.stateId}
                        </div>
                      )}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">
                        District <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className={`form-control ${userValidationErrors.districtId ? "is-invalid" : ""}`}
                        name="districtId"
                        onChange={userInputHandler}
                        value={userForm.districtId}
                        disabled={!userForm.stateId}
                      >
                        <option value="">--Select District--</option>
                        {districts?.map((district) => (
                          <option key={district?.id} value={district?.id}>
                            {district?.districtName}
                          </option>
                        ))}
                      </select>
                      {userValidationErrors.districtId && (
                        <div className="invalid-feedback">
                          {userValidationErrors.districtId}
                        </div>
                      )}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">
                        Pincode <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        maxLength={6}
                        className={`form-control ${userValidationErrors.pincode ? "is-invalid" : ""}`}
                        name="pincode"
                        value={userForm.pincode}
                        onChange={userInputHandler}
                      />
                      {userValidationErrors.pincode && (
                        <div className="invalid-feedback">
                          {userValidationErrors.pincode}
                        </div>
                      )}
                    </div>
                  </div></div>
              </div>

              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label">
                  User Type
                  <span className="ms-1" style={{ color: "red" }}>
                    *
                  </span>
                </label>
                <div className="col-sm-9 d-flex align-items-center flex-wrap">
                  {userTypes.map((type) => (
                    <div className="form-check me-3" key={type.value}>
                      <input
                        className={`form-check-input ${userValidationErrors.role ? "is-invalid" : ""}`}
                        type="radio"
                        name="role"
                        value={type.value}
                        onChange={userInputHandler}
                        checked={userForm.role === type.value}
                        disabled={Boolean(userToUpdate)}
                      />
                      <label className="form-check-label">
                        {type.label}
                      </label>
                    </div>
                  ))}
                  {userValidationErrors.role && (
                    <div className="invalid-feedback d-block">
                      {userValidationErrors.role}
                    </div>
                  )}
                </div>
              </div>

              {userForm.role && userForm.role !== "Advocate" && (
                <div className="form-group row mb-2">
                  <label className="col-sm-3 col-form-label">
                    Designation
                    <span className="ms-1" style={{ color: "red" }}>*</span>
                  </label>
                  <div className="col-sm-9">
                    <select
                      className={`form-control ${userValidationErrors.designationId ? "is-invalid" : ""}`}
                      name="designationId"
                      onChange={userInputHandler}
                      value={userForm.designationId}
                    >
                      <option value="">--Select Designation--</option>
                      {designations?.map((designation) => (
                        <option key={designation?.id} value={designation?.id}>
                          {designation?.designationName}
                        </option>
                      ))}
                    </select>
                    {userValidationErrors.designationId && (
                      <div className="invalid-feedback">
                        {userValidationErrors.designationId}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {(
                userForm.role === "Police" ||
                userForm.role === "StationHead" ||
                userForm.role === "DistrictHead"
              ) && (
                  <>
                    <div className="form-group row mb-2">
                      <label className="col-sm-3 col-form-label">
                        State <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="col-sm-9">
                        <select
                          className={`form-control ${userValidationErrors.policeStateId ? "is-invalid" : ""}`}
                          name="policeStateId"
                          value={userForm.policeStateId}
                          onChange={userInputHandler}
                          disabled={true}
                        >
                          <option value="">--Select State--</option>
                          {policeStates.map((state) => (
                            <option key={state.id} value={state.id}>
                              {state.stateName}
                            </option>
                          ))}
                        </select>
                        {userValidationErrors.policeStateId && (
                          <div className="invalid-feedback">
                            {userValidationErrors.policeStateId}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row mb-2">
                      <label className="col-sm-3 col-form-label">
                        District <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="col-sm-9">
                        <select
                          className={`form-control ${userValidationErrors.policeDistrictId ? "is-invalid" : ""}`}
                          name="policeDistrictId"
                          value={userForm.policeDistrictId}
                          onChange={userInputHandler}
                          disabled={disableBottomFields}
                        >
                          <option value="">--Select District--</option>
                          {policeDistricts.map((district) => (
                            <option key={district.id} value={district.id}>
                              {district.districtName}
                            </option>
                          ))}
                        </select>
                        {userValidationErrors.policeDistrictId && (
                          <div className="invalid-feedback">
                            {userValidationErrors.policeDistrictId}
                          </div>
                        )}
                      </div>
                    </div>

                    {(userForm.role === "Police" || userForm.role === "StationHead") && (
                      <div className="form-group row mb-2">
                        <label className="col-sm-3 col-form-label">
                          Police Station <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-9">
                          <select
                            className={`form-control ${userValidationErrors.policeStationId ? "is-invalid" : ""}`}
                            name="policeStationId"
                            value={userForm.policeStationId}
                            onChange={userInputHandler}
                            disabled={disableBottomFields}
                          >
                            <option value="">--Select Police Station--</option>
                            {policeStation.map((station) => (
                              <option key={station.id} value={station.id}>
                                {station.policeStationName}
                              </option>
                            ))}
                          </select>
                          {userValidationErrors.policeStationId && (
                            <div className="invalid-feedback">
                              {userValidationErrors.policeStationId}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {userForm.role === "Police" && (
                      <div className="form-group row mb-2">
                        <label className="col-sm-3 col-form-label">
                          Police Post <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-9">
                          <select
                            className={`form-control ${userValidationErrors.policePostId ? "is-invalid" : ""}`}
                            name="policePostId"
                            value={userForm.policePostId}
                            onChange={userInputHandler}
                            disabled={!userForm.policeStationId}
                          >
                            <option value="">--Select Police Post--</option>
                            {policePost.map((post) => (
                              <option key={post.id} value={post.id}>
                                {post.postName}
                              </option>
                            ))}
                          </select>
                          {userValidationErrors.policePostId && (
                            <div className="invalid-feedback">
                              {userValidationErrors.policePostId}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="form-group row mb-2">
                      <label className="col-sm-3 col-form-label">
                        {userForm.role === "StationHead" ? (
                          <>
                            Belt No / Batch No <span style={{ color: "red" }}>*</span>
                          </>
                        ) : (
                          "Belt No"
                        )}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className={`form-control ${userValidationErrors.beltNo ? "is-invalid" : ""}`}
                          name="beltNo"
                          value={userForm.beltNo}
                          onChange={userInputHandler}
                          maxLength={50}
                          disabled={disableBottomFields}
                        />
                        {userValidationErrors.beltNo && (
                          <div className="invalid-feedback">
                            {userValidationErrors.beltNo}
                          </div>
                        )}
                        {userForm.role === "StationHead" && (
                          <small className="form-text text-muted">
                            Enter Batch No in case of Trainee IPS/HPS
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}


              {userForm.role === "Advocate" && (
                <>
                  <div className="form-group row mb-2">
                    <label className="col-sm-3 col-form-label">
                      Name of the Bar Council <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control ${userValidationErrors.barCouncilName ? "is-invalid" : ""}`}
                        name="barCouncilName"
                        value={userForm.barCouncilName}
                        onChange={userInputHandler}
                      />
                      {userValidationErrors.barCouncilName && (
                        <div className="invalid-feedback">
                          {userValidationErrors.barCouncilName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="col-sm-3 col-form-label">
                      Enrollment / Registration Number / P No <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control ${userValidationErrors.provisionalNo ? "is-invalid" : ""}`}
                        name="provisionalNo"
                        value={userForm.provisionalNo}
                        onChange={userInputHandler}
                      />
                      {userValidationErrors.provisionalNo && (
                        <div className="invalid-feedback">{userValidationErrors.provisionalNo}</div>
                      )}
                    </div>
                  </div>

                  {/* <div className="form-group row mb-2">
                    <label className="col-sm-3 col-form-label">
                      Employee Code <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className={`form-control ${userValidationErrors.employeeCode ? "is-invalid" : ""}`}
                        name="employeeCode"
                        value={userForm.employeeCode}
                        onChange={userInputHandler}
                      />
                      {userValidationErrors.employeeCode && (
                        <div className="invalid-feedback">
                          {userValidationErrors.employeeCode}
                        </div>
                      )}
                    </div>
                  </div> */}
                </>
              )}

              <div className="d-flex justify-content-center mt-4">
                <button type="submit" className="btn btn-success btn-sm">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUpdateUser;